import React, {useState, useEffect} from 'react';
import OpenInNewLink from '../../../libs/react-components-admin/link/open-in-new-link';
import {aceCustId, defaultErrorHandler} from '../../../context/context';
import customFormsV2Client from '../../../infrastructure/acerill/custom-forms-v2-client';
import PreviousNext from './previous-next';
import CenteredSpinner from '../../../libs/react-components-admin/spinners/centered-spinner';

const Step2 = ({createdPage, onPreviousClicked, onDone}) => {

  const [forms, setForms] = useState();

  useEffect(() => {
    customFormsV2Client.findAllForms(false)
      .then(forms => setForms(forms))
      .catch(err => defaultErrorHandler(err));
  }, []);

  const createdTemplateLink = () => {
    return 'https://' + aceCustId + '/admin/themes/current/editor?previewPath=' +
      encodeURIComponent('/pages/' + createdPage.handle);
  };

  if (!forms) {
    return <CenteredSpinner/>;
  }
  return <>
    {createdPage ?
      <>In your <OpenInNewLink href={createdTemplateLink()}>theme editor</OpenInNewLink></> :
      <>Still in your theme editor</>
    }
    , enter some values (anything) and submit the form.
    <div className="my-3">
      You should see your <OpenInNewLink
      href={(forms.length === 1 ? '/forms/' + encodeURIComponent(forms[0].id) : '') + '/submissions?shop=' + aceCustId}>submission</OpenInNewLink>.
    </div>
    <PreviousNext onPreviousClicked={() => onPreviousClicked()} onNextClicked={() => onDone()}/>
  </>;
};

export default Step2;
